module.exports = __webpack_public_path__ + "static/media/female.8d8c67c6.svg";